import { gql } from '@apollo/client';

const CREATE_CREATOR_MUTATION = gql`
  mutation CreateCreatorMutation(
    $publisherId: Int!
    $displayName: String!
    $paymentName: String!
    $photoUrl: String!
    $biography: String!
    $paymentType: Int!
    $email: String!
    $phone: String!
    $website: String!
    $line1: String!
    $line2: String!
    $city: String!
    $state: String!
    $zipcode: String!
    $country: String!
  ) {
    createCreator(
      publisherId: $publisherId
      displayName: $displayName
      paymentName: $paymentName
      photoUrl: $photoUrl
      biography: $biography
      paymentType: $paymentType
      email: $email
      phone: $phone
      website: $website
      line1: $line1
      line2: $line2
      city: $city
      state: $state
      zipcode: $zipcode
      country: $country
    ) {
      id
      publisherId
      displayName
      paymentName
      paymentType
      photoUrl
      biography
      website
    }
  }
`;

export default CREATE_CREATOR_MUTATION;
